// FIXME: Don't remove Comment file there all in this type is not define we take any every where.
import React, { FC, useState, useEffect, useContext } from "react";
import Input from "../../components/UI/input/GgInput";
import Button from "../../components/UI/button/GgButton";
import RouteData, { IRouteData } from "../../router/RouterData";
import { Link } from "react-router-dom";
import { Context } from "../..";
import { showErrorToast } from "../../components/toasts";

interface IProps {
  hanldeUpdateUserData?: (id: string, e?: any) => void;
  fetchSigleUser?: any;
  setFetchSigleUser?: any;
  roles?: any;
}

export interface IRenderItem {
  item: IRouteData;
  index: number;
  // onClick: () => void
}

const EditUser: FC<IProps> = ({
  hanldeUpdateUserData,
  fetchSigleUser,
  setFetchSigleUser,
}) => {
  // state management
  const [selectedRoleList, setSelectedRoleList] = useState<any>(
    fetchSigleUser?.role || []
  );
  const [usePathname, setUsePathname] = useState<string>("");
  const [newRouteData, setNewRouteData] = useState<any>([]);
  const [newRoute, setNewRoute] = useState<any>([]);
  const [showButton, setShowButton] = useState<any>(false);
  const [updateUserPass, setUpdateUserPass] = useState<any>();

  const { roles } = useContext(Context);

  const resetNewRouteData = () => {
    const result = RouteData.map((item: any) => {
      if (item.hasOwnProperty("checked")) {
        return {
          ...item,
          checked: false,
        };
      } else {
        return item;
      }
    });
    const mainResult = result
      .filter((el) => el.title !== "404")
      .map((item: any) => {
        return {
          ...item,
          children: item?.children?.map((chItem: any) => {
            if (chItem.hasOwnProperty("checked")) {
              return {
                ...chItem,
                checked: false,
              };
            } else {
              return chItem;
            }
          }),
        };
      });
    setNewRouteData(mainResult);
  };

  useEffect(() => {
    const newData = [...RouteData];
    setNewRouteData(newData);

    return () => {
      resetNewRouteData();
    };
  }, []);

  useEffect(() => {
    const newData = newRouteData.filter((item: any) => item.checked);
    setNewRoute(newData);
  }, [newRouteData]);

  const RenderItem: FC<IRenderItem> = ({ item, index }) => {
    console.log(index);
    // state management

    const handleSelectAll = (RoleObj: any) => {
      const isRoleExist = selectedRoleList.find(
        (el: any) => el.title === RoleObj.title
      );

      if (isRoleExist) {
        const filterRoleList = selectedRoleList.filter(
          (el: any) => el.title !== RoleObj.title
        );
        setSelectedRoleList(filterRoleList);
      } else {
        setSelectedRoleList([...selectedRoleList, RoleObj]);
      }

      // const newArray = [...newRouteData];

      // // Check if the parent item has the 'checked' property, and if not, initialize it to true
      // if (!newArray[index].hasOwnProperty("checked")) {
      //   newArray[index].checked = true;
      // } else {
      //   newArray[index].checked = !newArray[index].checked; // Toggle the checked property for the parent
      // }

      // if (newArray[index].children) {
      //   const data = newArray[index].children.map((item: any) => {
      //     // Check if the child item has the 'checked' property, and if not, initialize it to true
      //     if (!item.hasOwnProperty("checked")) {
      //       item.checked = true;
      //     } else {
      //       item.checked = newArray[index].checked; // Toggle the checked property for the child
      //     }
      //     return item;
      //   });
      // }

      // setNewRouteData(newArray);
    };

    const handleChildSelect = (roleObj: any, childItem: any) => {
      const isRoleExist = selectedRoleList?.find(
        (el: any) => el.title === roleObj.title
      );
      const isChildRoleExist = selectedRoleList.some((el: any) =>
        el.children.find((childEl: any) => childEl.title === childItem.title)
      );

      if (isRoleExist) {
        if (isChildRoleExist) {
          const filterChildData = selectedRoleList.map((item: any) => {
            return {
              ...item,
              children: item.children.some(
                (itemEl: any) => itemEl.title === childItem.title
              )
                ? item.children.filter(
                    (flEl: any) => flEl.title !== childItem.title
                  )
                : item.children,
            };
          });
          setSelectedRoleList(filterChildData);
        } else {
          const newData = selectedRoleList.map((roleEl: any) => {
            if (roleEl.title === roleObj.title) {
              return {
                ...roleEl,
                children: [...roleEl.children, childItem],
              };
            } else {
              return roleEl;
            }
          });
          setSelectedRoleList(newData);
        }
      } else {
        const newData = {
          ...roleObj,
          children: roleObj?.children?.filter(
            (el: any) => el.title === childItem.title
          ),
        };
        setSelectedRoleList([...selectedRoleList, newData]);
      }
      //====

      // const isExist = allSelectedChildField.find((el: string) => el === childTitle)
      // if (isExist) {
      //   const filteredData = allSelectedChildField.filter((el: string) => el !== childTitle)
      //   setAllSelectedChildField(filteredData)
      // } else {
      //   const result = [...allSelectedChildField, childTitle]
      //   setAllSelectedChildField(result)
      // }

      // const newArray = [...newRouteData]
      // const parentElement = {
      //   ...newArray[parrnetIndex]
      // }
      // if (parentElement.children[childIndex].checked === "undefined" || !parentElement.children[childIndex].checked) {
      //   parentElement.children[childIndex].checked = true
      // } else {
      //   parentElement.children[childIndex].checked = false
      // }
      // newArray[parrnetIndex] = parentElement
      // setNewRouteData(newArray)
    };

    const childCheckedStatus = (title: string, childTitle: string) => {
      let result = false;

      const roleData = selectedRoleList?.find((el: any) => el.title === title);
      if (roleData) {
        const isExist = roleData?.children?.find(
          (childEl: any) => childEl.title === childTitle
        );

        if (isExist) {
          result = true;
        }
      }
      return result;
    };

    return (
      <>
        {item.children?.length ? (
          <div>
            <div
              className={`item ${usePathname === item.path && "active"}`}
              style={{ display: "flex", fontWeight: "800" }}
            >
              {/* @ts-ignore */}
              <input
                type="checkbox"
                id=""
                style={{ marginRight: "0.3rem" }}
                checked={
                  selectedRoleList.some((el: any) => el.title === item.title)
                    ? true
                    : false
                }
                onClick={(e) => {
                  e.preventDefault();
                  // @ts-ignore
                  handleSelectAll(item);
                }}
              />
              <div className="name">{item.title}</div>
            </div>
            <div style={{ marginLeft: "1rem" }}>
              {item?.children.map((itemChild, i) => {
                const newData = itemChild;
                return (
                  <>
                    <div style={{ display: "flex", padding: "0.3rem" }}>
                      {/* @ts-ignore */}
                      <input
                        type="checkbox"
                        id=""
                        style={{ marginRight: "0.3rem" }}
                        checked={childCheckedStatus(
                          item.title,
                          itemChild.title
                        )}
                        onClick={() => handleChildSelect(item, itemChild)}
                      />
                      <div className="name">{newData.title}</div>
                    </div>
                    {childCheckedStatus(item.title, itemChild.title) && (
                      <div style={{ marginLeft: "1rem" }}>
                        {newData.hasOwnProperty("add") ? (
                          <div style={{ display: "flex", padding: "0.3rem" }}>
                            {/* @ts-ignore */}
                            <input
                              type="checkbox"
                              style={{ marginRight: "0.3rem" }}
                              checked={
                                [...selectedRoleList].find(
                                  (e) => e.title === item.title
                                )?.children?.[i]?.add
                              }
                              onChange={(e) => {
                                const newSelected = [...selectedRoleList].find(
                                  (e) => e.title === item.title
                                );

                                newSelected.children[i].add = e.target.checked;

                                const changedItem = [...selectedRoleList].map(
                                  (el: any) => {
                                    if (el.title === item.title) {
                                      return newSelected;
                                    } else {
                                      return el;
                                    }
                                  }
                                );

                                setSelectedRoleList(changedItem);
                              }}
                            />
                            <div className="edit">
                              <span>Add</span>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {newData.hasOwnProperty("edit") ? (
                          <div style={{ display: "flex", padding: "0.3rem" }}>
                            {/* @ts-ignore */}
                            <input
                              type="checkbox"
                              id=""
                              style={{ marginRight: "0.3rem" }}
                              checked={
                                [...selectedRoleList].find(
                                  (e) => e.title === item.title
                                )?.children?.[i]?.edit
                              }
                              onChange={(e) => {
                                const newSelected = [...selectedRoleList].find(
                                  (e) => e.title === item.title
                                );

                                newSelected.children[i].edit = e.target.checked;

                                const changedItem = [...selectedRoleList].map(
                                  (el: any) => {
                                    if (el.title === item.title) {
                                      return newSelected;
                                    } else {
                                      return el;
                                    }
                                  }
                                );

                                setSelectedRoleList(changedItem);
                              }}
                            />
                            <div className="name">
                              <span>Edit</span>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {newData.hasOwnProperty("delete") ? (
                          <div style={{ display: "flex", padding: "0.3rem" }}>
                            {/* @ts-ignore */}
                            <input
                              type="checkbox"
                              id=""
                              style={{ marginRight: "0.3rem" }}
                              checked={
                                [...selectedRoleList].find(
                                  (e) => e.title === item.title
                                )?.children?.[i]?.delete
                              }
                              onChange={(e) => {
                                const newSelected = [...selectedRoleList].find(
                                  (e) => e.title === item.title
                                );

                                newSelected.children[i].delete = e.target.checked;

                                const changedItem = [...selectedRoleList].map(
                                  (el: any) => {
                                    if (el.title === item.title) {
                                      return newSelected;
                                    } else {
                                      return el;
                                    }
                                  }
                                );

                                setSelectedRoleList(changedItem);
                              }}
                            />
                            <div className="name">
                              <span>Delete</span>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    )}
                  </>
                );
              })}
            </div>
          </div>
        ) : (
          <>
            {item.visible && (
              <Link
                to={`/admin${item.path}`}
                className={`item ${usePathname === item.path && "active"}`}
              >
                <div className="icon-container">{item.icon}</div>
                <div className="name">{item.title}</div>
              </Link>
            )}
          </>
        )}
      </>
    );
  };

  // const handleUpdatePassword = async () => {
  //   const id = fetchSigleUser._id
  //   console.log({updateUserPass})
  //   await roles.updateUserPassword(id, updateUserPass).then(() => {
  //     setShowButton(false)
  //     setUpdateUserPass("")
  //   }).catch((err: any) => {
  //     showErrorToast(err)
  //   })
  // }

  return (
    <div id="calc-details" className="calc-details">
      <Input
        type="text"
        label="Name"
        value={fetchSigleUser?.name}
        placeholder="Name"
        required={true}
        onChange={(vl) => setFetchSigleUser({ ...fetchSigleUser, name: vl })}
      />
      <Input
        type="text"
        label="Email"
        value={fetchSigleUser?.email}
        placeholder="Email"
        required={true}
        onChange={(vl) => setFetchSigleUser({ ...fetchSigleUser, email: vl })}
      />
      {/* <Input
        type="text"
        label="Password"
        value={fetchSigleUser?.password}
        placeholder="Password"
        required={true}
        onChange={(vl) => setFetchSigleUser({ ...fetchSigleUser, password: vl })}
      />
       */}
      {/* TODO: Change Password Feature */}
      {/* TODO: Start */}
      {/* {!showButton  ? (
          <div style={{display:"flex", justifyContent:"center", padding:"1rem"}}>
          <Button 
            label="Chnage Password" 
            type="submit" 
            style={{width:"20%"}}
            onPress={() => {setShowButton(true)}}
            />
        </div>
        ) : (  
        <div>
          <div style={{display:"flex"}}>
            <Input
              type="text"
              label="Old Password"
              style={{width:"90%"}}
              value={updateUserPass?.oldPassword}
              placeholder="Old Password"
              required={true}
              onChange={(vl) => setUpdateUserPass({ ...updateUserPass, oldPassword: vl })}
            />
            <Input
              type="text"
              label="New Password"
              style={{width:"90%"}}
              value={updateUserPass?.newPassword}
              placeholder="New Password"
              required={true}
              onChange={(vl) => setUpdateUserPass({ ...updateUserPass, newPassword: vl })}
            />
            <Input
              type="text"
              label="Confirm New Password"
              style={{width:"90%"}}
              value={updateUserPass?.confirmPassword}
              placeholder="Confirm Password"
              required={true}
              onChange={(vl) => setUpdateUserPass({ ...updateUserPass, confirmPassword: vl })}
            />
          </div>
          <div style={{display:"flex", justifyContent:"center", padding:"1rem"}}>
            <Button 
              label="Save" 
              type="submit" 
              style={{width:"20%"}}
              onPress={() => {handleUpdatePassword()}}
              />
          </div>
        </div>
        )} */}
      {/* TODO: END */}
      <div className="title">Role</div>
      <div style={{ display: "flex", justifyContent: "space-around" }}>
        {newRouteData.map((item: any, index: number) => {
          item.index = index;
          return (
            <div>
              <RenderItem item={item} index={index} />
            </div>
          );
        })}
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button
          label="Submit"
          className=""
          type="button"
          style={{
            width: "7rem",
            position: "absolute",
            top: "0%",
            right: "0%",
            zIndex: "999",
            margin: "2rem 5rem",
          }}
          onPress={() => {
            hanldeUpdateUserData &&
              hanldeUpdateUserData(fetchSigleUser._id, selectedRoleList);
          }}
        />
      </div>
    </div>
  );
};

export default EditUser;
